import { graphql, useStaticQuery } from "gatsby";
import {
  extract,
  ShowStore,
  RideStore,
  RestaurantStore,
  PlaceholderImageHelper,
  TextBlockStore,
} from "@parksandresorts/core";
import "components/blocks/my-page-block/query";

/** @returns {import("@parksandresorts/core").SimplifyGatsbyQuery<Queries.StaticDataQuery>} */
export const useStaticData = () => {
  const data = useStaticQuery(query);
  return data;
};

const StaticDataFactory = (props) => {
  const data = useStaticData();

  ShowStore.populateStore(extract(data, "allContentfulShowBlock.edges"));
  RideStore.populateStore(extract(data, "allContentfulRideBlock.edges"));
  RestaurantStore.populateStore(extract(data, "allContentfulRestaurantBlock.edges"));
  TextBlockStore.populateStore(extract(data, "allContentfulTextBlock.nodes"));

  PlaceholderImageHelper.setPlaceholderImages({
    eventRow: "/icon-192x192.png",
    cartItem: "/icon-192x192.png",
    sendGift: "/furuvik-send-gift.png",
    myParksGiftWrapper: "/images/my-pages/rod-rosett.png",
  });

  return <>{props.children}</>;
};

const query = graphql`
  query StaticData {
    allGlkProduct {
      nodes {
        ...GLKProduct
      }
    }
    allContentfulProductBlock(filter: { productName: { ne: null } }) {
      edges {
        node {
          ...ProductBlock
        }
      }
    }
    allContentfulShowBlock {
      edges {
        node {
          ...ShowBlock
        }
      }
    }
    allContentfulRideBlock(filter: { title: { ne: null } }) {
      edges {
        node {
          ...RideBlockStore
        }
      }
    }
    allContentfulRestaurantBlock(filter: { title: { ne: null } }) {
      edges {
        node {
          node_locale
          ...RestaurantBlock
        }
      }
    }
    allContentfulTextBlock(filter: { richText: { raw: { ne: null } } }) {
      nodes {
        id
        contentful_id
        node_locale
        internalTitle
        componentTheme
        richText {
          raw
          references {
            __typename
            ...Link
            ...Asset
          }
        }
        image {
          gatsbyImageDataXs: gatsbyImageData(width: 512)
          gatsbyImageDataS: gatsbyImageData(width: 640)
          gatsbyImageDataM: gatsbyImageData(width: 960)
          gatsbyImageDataL: gatsbyImageData(width: 1440)
          gatsbyImageDataCornerMobile: gatsbyImageData(width: 100, height: 100)
          gatsbyImageDataCornerDesktop: gatsbyImageData(width: 200, height: 200, outputPixelDensities: [1])
          description
        }
        animation {
          url
        }
        useCustomColors
        customColors {
          backgroundColor
          textColor
          headingColor
          neonColorBase
          neonColorShine
          linkColor
          buttonTextColor
          buttonBackgroundColor
        }
      }
    }
    # this filters out the mocked entity (similar to our GraphQL-entries in Contentful)
    allGlkOpeningHours(filter: { opens: { lt: "2099" } }) {
      nodes {
        id
        internal {
          type
          content
        }
      }
    }
  }
`;

export default StaticDataFactory;
